import { GetDailyBonusInfoDTO, GetFarcanaBonusInfoDTO } from './types'
import { http } from '@/shared/http.ts'

export const getDailyBonusInfo = async (token: string): Promise<GetDailyBonusInfoDTO> => {
  return await http.get<GetDailyBonusInfoDTO>('/bonus/get-daily-info', {
    token,
  })
}
export const getFarcanaBonusInfo = async (token: string): Promise<GetFarcanaBonusInfoDTO> => {
  return await http.get<GetFarcanaBonusInfoDTO>('/bonus/get-farcana-info', {
    token,
  })
}

export const postClaimDailyBonus = async (token: string, day: number, is_premium: boolean) => {
  return await http.post(
    '/bonus/claim-daily-bonus/',
    {
      token,
      body: {
        day,
        is_premium,
      },
    },
  )
}

export const postClaimFarcanaBonus = async (token: string, day: number) => {
  return await http.post(
    '/bonus/claim-farcana-bonus/',
    {
      token,
      body: {
        day,
      },
    },
  )
}
